<template>
        <div class="mb-5">
            <div class="max-w-7xl mx-auto py-10 sm:px-6 lg:px-8">
                <div v-if="$page.props.jetstream.canUpdateProfileInformation">
                    <update-profile-information-form :user="$page.props.user" class="mb-5"/>
                </div>

                <div v-if="$page.props.jetstream.canUpdatePassword">
                    <update-password-form class="mb-5"/>
                </div>

                <div v-if="user && user.roles === 'user'">
                    <employement-info-vue :employement_info="$page.props.employement_info" />
                </div>

                <logout-other-browser-sessions-form :sessions="sessions" class="mt-10 sm:mt-0"/>
            </div>
        </div>
</template>

<script>
import AppLayout from '../../Layouts/AppLayout'
import LogoutOtherBrowserSessionsForm from '@/Pages/Profile/Partials/LogoutOtherBrowserSessionsForm.vue'
import UpdatePasswordForm from '@/Pages/Profile/Partials/UpdatePasswordForm.vue'
import UpdateProfileInformationForm from '@/Pages/Profile/Partials/UpdateProfileInformationForm.vue'
import EmployementInfoVue from '@/Pages/Profile/Partials/EmployementInfo.vue'

export default {
    props: ['sessions'],
    layout: AppLayout,
    components: {
        LogoutOtherBrowserSessionsForm,
        UpdatePasswordForm,
        UpdateProfileInformationForm,
        EmployementInfoVue,
    },
    data(){
        return {
            user: JSON.parse(sessionStorage.getItem('auth:me')),
        }
    }
}
</script>
